import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloViguetaWpc from '../components/sections/ViguetaWpc/TituloViguetaWpc';
import IntroViguetaWpc from '../components/sections/ViguetaWpc/IntroViguetaWpc';
import DescripcionViguetaWpc from '../components/sections/ViguetaWpc/DescripcionViguetaWpc';
import AplicacionesViguetaWpc from '../components/sections/ViguetaWpc/AplicacionesViguetaWpc';
import FormularioContactoViguetaWpc from '../components/sections/ViguetaWpc/FormularioContactoViguetaWpc';
import VigasPVCSector from '../components/sections/VigasPVCSector';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';  

const ViguetaWpcPage = () => {
  return (
    <div>
      <SeoMetadata
        title="Vigueta WPC | Decototal"
        description="Descubre viguetas WPC para proyectos de construcción y decoración. Consulta usos, características y disponibilidad con Decototal."
        keywords="vigueta WPC, vigueta sintética, vigueta para construcción, perfiles WPC"
        path="/vigueta-wpc-page"
        image="/assets/img/productos/vigueta-wpc/vigueta-wpc-titulo.jpg"
      />
      <Header />
        <TituloViguetaWpc />  
        <IntroViguetaWpc />   
        <DescripcionViguetaWpc /> 
        <AplicacionesViguetaWpc /> 
        <VigasPVCSector />
        <FormularioContactoViguetaWpc />  
      <Footer />  
    </div>
  );
};

export default ViguetaWpcPage;